<template>
  <p class="clearfix mb-0">
    <span class="float-md-left d-block d-md-inline-block mt-25">
      ROSYMAR © {{ new Date().getFullYear() }}
      <b-link class="ml-25" href="#" target="_blank">ZergSoft</b-link>
      <span class="d-none d-sm-inline-block">, All rights Reserved</span>
    </span>

    <span class="float-md-right d-none d-md-block">
      Zerg Soft
      <div class="truck-animation">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          class="icon icon-tabler icon-tabler-truck"
          width="100"
          height="100"
          viewBox="0 0 24 24"
          stroke-width="1.5"
          stroke="#ff4500"
          fill="none"
          stroke-linecap="round"
          stroke-linejoin="round"
        >
          <path stroke="none" d="M0 0h24v24H0z" fill="none" />
          <circle cx="7" cy="17" r="2" />
          <circle cx="17" cy="17" r="2" />
          <path
            d="M5 17h-2v-11a1 1 0 0 1 1 -1h9v12m-4 0h6m4 0h2v-6h-8m0 -5h5l3 5"
          />
        </svg>
      </div>
    </span>
  </p>
</template>

<script>
import { BLink } from "bootstrap-vue";

export default {
  components: {
    BLink,
  },
};
</script>
<style >
:root {
  --left-offset: calc(75vw * -1);
}

.truck-animation {
  position: relative;
  display: inline-block;
  animation-name: drive;
  animation-duration: 7s;
  animation-timing-function: ease-in-out;
  animation-delay: 0s;
  animation-direction: alternate;
}
@keyframes drive {
  0% {
    left: var(--left-offset);
  }
  50% {
    left: 0;
  }
  100% {
    left: 0;
  }
}
</style>
```